<script setup lang="ts">
import { useMessagesStore } from '../../../stores/messagesStore'
import mdiClose from '~icons/mdi/close'

const messages = useMessagesStore()
</script>

<template>
  <v-snackbar-queue
    v-model="messages.queue"
    location="bottom center"
    :timeout="5000"
    :total-visible="5"
    collapsed
    closable
  >
    <template #actions="{ item, props: actionProps }">
      <v-btn
        v-if="typeof item === 'string' || item.timeout !== -1"
        v-bind="actionProps"
        icon
      >
        <v-icon :icon="mdiClose" />
        <v-tooltip
          :text="$t('common.close')"
          location="top"
          activator="parent"
        />
      </v-btn>
    </template>
  </v-snackbar-queue>
</template>
